import { Box, Stack, Typography } from "@mui/material";
import useQueryState from "../../../../hooks/useQueryState";
import { INDICES_WITH_HYBRID } from "../enums";
import { MAP_LEGEND } from "../../../../enums/layers";
import DroughtIndicesMap from "./partials/DroughtIndicesMap";
import Slider from "../../../../Components/Slider";

const DroughtIndices = () => {
  const {
    queryState: {
      season,
      layers,
      ui: { mainSidebar, mapSidebar },
    },
  } = useQueryState();

  const activeColumns = INDICES_WITH_HYBRID.map((index) => {
    const activeSeasons = season.filter((s) =>
      layers.some(
        (l) => l.displayName === index.name && l.season === s && l.active,
      ),
    );

    return {
      ...index,
      seasons: activeSeasons,
    };
  }).filter((col) => col.seasons.length > 0);

  return (
    <Stack flex={1} minHeight={0} overflow="hidden" position="relative">
      {/* ===== Header ===== */}
      <Stack
        direction="row"
        justifyContent="space-between"
        minHeight="2rem"
        alignItems="center"
      >
        {activeColumns.map(({ name, icon }) => (
          <Stack
            key={name}
            direction="row"
            flex={1}
            justifyContent="center"
            alignItems="center"
            gap={1}
          >
            {icon}
            <Typography variant="subtitle1">{name}</Typography>
          </Stack>
        ))}
      </Stack>

      {/* ===== Map Area ===== */}
      {season.length === 0 || layers.length === 0 ? (
        <Stack
          flex={1}
          justifyContent="center"
          alignItems="center"
          border="1px solid lightgray"
          borderRadius="8px"
        >
          <Typography variant="caption" color="gray">
            Activate season to preview the map
          </Typography>
        </Stack>
      ) : (
        <Stack
          direction="row"
          flex={1}
          minHeight={0}
          gap={0.5}
          px={0.5}
          overflow="hidden"
          key={`${mainSidebar}-${mapSidebar}-${season.length}`}
        >
          {activeColumns.map((col) => (
            <Stack key={col.name} flex={1} minHeight={0} gap={0.5}>
              {col.seasons.map((s) => {
                const columnLayers = layers.filter(
                  (l) => l.displayName === col.name && l.season === s,
                );

                return (
                  <Stack key={`${col.name}-${s}`} flex={1} minHeight={0}>
                    <DroughtIndicesMap
                      season={s}
                      layers={columnLayers}
                      color={col.color}
                    />
                  </Stack>
                );
              })}
            </Stack>
          ))}
        </Stack>
      )}

      {/* ===== Legend ===== */}
      <Stack flexShrink={0} px={0.5}>
        <Stack direction="row" justifyContent="space-between">
          {Object.entries(MAP_LEGEND).map(([key, legend]) => (
            <Stack
              key={key}
              direction="row"
              gap={0.5}
              alignItems="center"
              minHeight="3rem"
            >
              <Box
                width="1rem"
                height="1rem"
                bgcolor={legend.color}
                borderRadius="4px"
                border="1px solid rgba(0,0,0,0.6)"
              />
              <Typography variant="caption">{legend.label}</Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>

      {/* ===== Slider ===== */}
      <Stack flexShrink={0} minHeight="44px">
        <Slider />
      </Stack>
    </Stack>
  );
};

export default DroughtIndices;
